/**
 * AccordionSection Component
 * Collapsible section for tablet dashboard layout
 */
import React from 'react';
import { ChevronDown } from 'lucide-react';

export interface AccordionSectionProps {
  /** Section title displayed in the header */
  title: string;
  /** Whether the section is currently expanded */
  isOpen: boolean;
  /** Callback when the section header is clicked */
  onToggle: () => void;
  /** Content to render inside the section when expanded */
  children: React.ReactNode;
  /** Optional CSS class name */
  className?: string;
}

export function AccordionSection({
  title,
  isOpen,
  onToggle,
  children,
  className = '',
}: AccordionSectionProps) {
  return (
    <div className={`border border-theme-border bg-theme-bg-content/50 rounded-lg mb-3 ${className}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 text-left
                   bg-theme-bg-content hover:bg-theme-bg-content/80 transition-colors
                   min-h-[48px] rounded-t-lg"
        aria-expanded={isOpen}
      >
        <span className="font-semibold text-theme-text-primary text-lg">
          {title}
        </span>
        <ChevronDown
          className={`w-5 h-5 text-theme-text-secondary transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      {isOpen && (
        <div className="p-4 space-y-4 border-t border-theme-border bg-theme-bg-content/50">
          {children}
        </div>
      )}
    </div>
  );
}

export default AccordionSection;
